import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    type: "text",
    disabled: $setup.prop_disabled,
    onFocusout: _cache[0] || (_cache[0] = $event => ($setup.focusout())),
    onFocusin: _cache[1] || (_cache[1] = $event => ($setup.focusin($event, $setup.dat_error))),
    onInput: _cache[2] || (_cache[2] = $event => ($setup.input($event))),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.dat_text) = $event)),
    class: _normalizeClass($setup.classes($setup.dat_error))
  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1)), [
    [_vModelText, $setup.dat_text]
  ])
}